function sortSizes (element) {
  if (!element) return

  const items = Array.from(element.querySelectorAll('[data-sort]'))
  if (!items.length) return

  const sortOrder = [
    'XXXS',
    'XXS',
    'XS',
    'S',
    'S+',
    'S++',
    'S+++',
    'M',
    'L',
    'XL',
    'XXL',
    'XXXL',
  ]

  const sortedItems = items.map((item) => item).sort((a, b) => {
    const aValue = a.dataset.sort
    const bValue = b.dataset.sort

    // Sort the items
    if (!isNaN(aValue) && !isNaN(bValue)) {
      // Sort numerically if both values are numbers
      return aValue - bValue
    } else {
      // Otherwise, sort by the index of the `sortOrder` array
      return sortOrder.indexOf(aValue) - sortOrder.indexOf(bValue)
    }
  })

  // Iterate over the sorted items and update the DOM
  sortedItems.forEach((item) => {
    element.appendChild(item)
  })
}

function getFocusableElements (container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

document.querySelectorAll('[id^="HeaderMenu-Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)

  if (summary.classList.contains('hd-Banner_ItemSummary')) {
    summary.addEventListener('mouseenter', (event) => {
      closeMegaMenu()

      event.target.parentNode.setAttribute('open', true)
    })
  }

  document.querySelector('.hd-Banner_ItemsParent')?.addEventListener('mouseleave', (event) => {
    if (event.relatedTarget?.classList.contains('hd-Banner_Nav')) {
      return
    }

    closeMegaMenu()
  })
})

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) { return }

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

function pauseAllMedia () {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function closeMegaMenu () {
  document.querySelectorAll('[id^="HeaderMenu-Details-"][open]').forEach((openSummary) => {
    openSummary.removeAttribute('open')
  })
}

function onKeyUpEscape (event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

class ModalDialog extends HTMLElement {
  constructor () {
    super()
    const closeBtns = this.querySelectorAll('[id^="ModalClose-"]')
    Array.from(closeBtns).forEach(btn => {
      btn.addEventListener(
        'click',
        this.hide.bind(this),
      )
    })
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  show (opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()

    if (this.dataset.gaEl) {
      this.pushToDataLayer('open')
    }
  }

  hide () {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()

    if (this.dataset.gaEl) {
      this.pushToDataLayer('close')
    }
  }

  pushToDataLayer (action) {
    const modalName = this.dataset.gaVariableTitle

    if (this.dataset.gaEl === 'pdpDetailsAccordion') {
      window.dataLayer.push({
        event: 'pdp_accordion',
        pdpAccordion: {
          accordion_name: modalName,
          click_action: action,
        },
      })
    }
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor () {
    super()

    const button = this.querySelector('button')

    if (!button) return

    button.addEventListener('click', (event) => {
      event.preventDefault()
      const modal = document.querySelector(this.getAttribute('data-modal'))

      if (modal) modal.show(button)

      const modalId = event.currentTarget.dataset.id

      if (modalId !== 'new-size-guide') return

      const modifier = event.currentTarget.dataset.modifier
      this.setActiveSizeGuideTab(modalId, modifier)
    })
  }

  setActiveSizeGuideTab (modalId, modifier) {
    const sizeGuideModal = document.querySelector(`#PopupModal-${modalId}`)
    const sizeGuideTabs = document.querySelector('vb-tabs.size-guide_tabs')
    const sizeGuideTabButtons = sizeGuideModal.querySelectorAll('.js-size-guide_tab')
    const trueToSizeTab = [...sizeGuideTabButtons].filter(el => el.dataset.tabName === 'true-to-size')

    if (!trueToSizeTab) return

    const activeTab = modifier && modifier === 'true-to-size' ? trueToSizeTab[0] : sizeGuideTabButtons[0]
    sizeGuideTabs.setSelectedTab(activeTab)
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor () {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent () {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor () {
    super()
    this.scrollMultiple = { scrolling: false, endPoint: null }
  }

  connectedCallback () {
    this.init()
  }

  getSliderGap () {
    const computedStyle = window.getComputedStyle(this.slider)
    const gap = computedStyle.gap || computedStyle.columnGap || '0px'
    return parseFloat(gap) || 0
  }

  init () {
    this.slider = this.querySelector('ul')
    this.sliderItems = this.slider?.querySelectorAll(':scope > li') || []
    this.pageCount = this.querySelector('.slider-counter--current')
    this.pageTotal = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')
    this.progressTrack = this.querySelector('.slider-progress')
    this.progressThumb = this.querySelector('.slider-progress-thumb')
    this.loadMoreButton = this.querySelector('button[name="load-more"]')
    this.viewLessButton = this.querySelector('button[name="view-less"]')

    if (!this.slider) return

    const resizeObserver = new ResizeObserver(() => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
    }
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.onLoadMoreButtonClick.bind(this))
    }
    if (this.viewLessButton) {
      this.viewLessButton.addEventListener('click', this.onViewLessButtonClick.bind(this))
    }

    if (this.querySelector('.slider-dots')) {
      this.renderDots()
    }
    if (this.querySelector('.slider-thumbnail-dots')) {
      this.initThumbnailDots()
    }

    if (!this.prevButton && !this.nextButton && this.progressThumb) {
      this.slider.addEventListener('scroll', this.animateProgressThumb.bind(this))
    }
  }

  initPages () {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0)
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1]

    if (sliderItemsToShow.length === 0) return

    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth)
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1

    this.update()
  }

  update (e) {
    if (!this.pageCount || !this.pageTotal) return
    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderLastItem.clientWidth + gap
    this.currentPage = Math.round(this.slider.scrollLeft / slideWidthWithGap) + 1

    this.pageCount.textContent = this.currentPage
    this.pageTotal.textContent = this.totalPages

    this.updateDots()

    if (!this.prevButton || !this.nextButton) return

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled')
      this.prevButton.setAttribute('aria-disabled', 'true')
    } else {
      this.prevButton.removeAttribute('disabled')
      this.prevButton.removeAttribute('aria-disabled')
    }

    if (this.currentPage === this.totalPages || this.currentPage > this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled')
      this.nextButton.setAttribute('aria-disabled', 'true')
    } else {
      this.nextButton.removeAttribute('disabled')
      this.nextButton.removeAttribute('aria-disabled')
    }

    this.animateProgressThumb()
  }

  renderDots () {
    const wrapper = this.querySelector('.slider-dots')

    if (!wrapper) return

    wrapper.innerHTML = ''

    this.sliderItems.forEach((el, index) => {
      const dot = document.createElement('button')
      dot.classList.add('dot')
      dot.setAttribute('type', 'button')
      dot.setAttribute('data-index', index)
      dot.addEventListener('click', this.onDotClick.bind(this))

      const isCurrentDot = index === Number(this.pageCount.textContent)
      dot.setAttribute('aria-current', isCurrentDot)

      wrapper.appendChild(dot)
    })
  }

  initThumbnailDots () {
    const wrapper = this.querySelector('.slider-thumbnail-dots')

    if (!wrapper) return

    const thumbailDots = wrapper.querySelectorAll('.dot')

    thumbailDots.forEach((el) => {
      el.addEventListener('click', this.onDotClick.bind(this))
    })
  }

  updateDots () {
    const wrappers = this.querySelectorAll('.slider-dots, .slider-thumbnail-dots')

    if (!wrappers?.length || this.scrollMultiple.scrolling) return

    wrappers.forEach(wrapper => {
      wrapper.querySelectorAll('.dot').forEach(dotEl => {
        dotEl.setAttribute('aria-current', 'false')
      })

      const currentDot = wrapper.querySelectorAll('.dot')?.[this.currentPage - 1]

      if (!currentDot) return

      currentDot.setAttribute('aria-current', 'true')

      if (this.classList.contains('menu-drawer__carousel')) return

      if (window.innerWidth > 989) currentDot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    })
  }

  onDotClick (event) {
    const clickedDot = event.target.closest('.dot')
    const dotIndex = clickedDot.getAttribute('data-index')
    const gap = this.getSliderGap()
    const slideScrollPosition = (this.sliderItems[0].clientWidth + gap) * dotIndex
    this.scrollMultiple = { scrolling: true, endPoint: slideScrollPosition }
    this.querySelectorAll('.dot').forEach((dotEl, index) => {
      dotEl.setAttribute('aria-current', index.toString() === dotIndex)
    })

    const checkIfScrollToIsFinished = setInterval(() => {
      if (this.scrollMultiple.endPoint === this.slider.scrollLeft) {
        this.scrollMultiple.scrolling = false
        clearInterval(checkIfScrollToIsFinished)
      }
    }, 25)

    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  onButtonClick (event) {
    event.preventDefault()

    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderLastItem.clientWidth + gap
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + slideWidthWithGap : this.slider.scrollLeft - slideWidthWithGap

    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth',
    })
  }

  onLoadMoreButtonClick (event) {
    event.preventDefault()
    event.target.hidden = true
    this.querySelector('ul[name="secondary-product-list"]').removeAttribute('aria-hidden', 'true')
    this.querySelector('button[name="view-less"]').hidden = false
  }

  onViewLessButtonClick (event) {
    event.preventDefault()
    event.target.hidden = true
    this.querySelector('ul[name="secondary-product-list"]').setAttribute('aria-hidden', 'true')
    this.querySelector('button[name="load-more"]').hidden = false
  }

  animateProgressThumb () {
    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderItems[0].clientWidth + gap
    const totalSliderWidth = (slideWidthWithGap * this.sliderItems.length) - gap
    const scrollLeftPercentage = this.slider.scrollLeft / totalSliderWidth
    if (this.progressThumb) this.progressThumb.style.left = `${Math.round(this.progressTrack.clientWidth * scrollLeftPercentage)}px`
  }
}

customElements.define('slider-component', SliderComponent);

(function () {
  const links = document.links
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank'
      links[i].rel = 'noreferrer noopener'
    }
  }
})()
